// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "transitTooltip__title-AdQLf";
var _3 = "transitTooltip-3FpLI";
var _4 = "transitTooltip__text-_MJ-h";
export { _1 as "__esModule", _2 as "transitTooltip__title", _3 as "transitTooltip", _4 as "transitTooltip__text" }
export default { "__esModule": _1, "transitTooltip__title": _2, "transitTooltip": _3, "transitTooltip__text": _4 }
